const GET_FORM_VALUES = 'publicadorProf/descriptionStep/GET_FORM_VALUES';
const GET_FORM_VALUES_COMPLETED = 'publicadorProf/descriptionStep/GET_FORM_VALUES_COMPLETED';
const GET_FORM_VALUES_FAILED = 'publicadorProf/descriptionStep/GET_FORM_VALUES_FAILED';
const SET_FORM_VALUES = 'publicadorProf/descriptionStep/SET_FORM_VALUES';

const GET_SUGGESTED_DATA = 'publicadorProf/descriptionStep/GET_SUGGESTED_DATA';
const GET_SUGGESTED_DATA_COMPLETED = 'publicadorProf/descriptionStep/GET_SUGGESTED_DATA_COMPLETED';
const GET_SUGGESTED_DATA_FAILED = 'publicadorProf/descriptionStep/GET_SUGGESTED_DATA_FAILED';
const RESET_SUGGESTED_DATA = 'publicadorProf/descriptionStep/RESET_SUGGESTED_DATA';

const RESET_INFO = 'publicador/ducks/descriptionStep/RESET_INFO';

export {
  GET_FORM_VALUES,
  GET_FORM_VALUES_COMPLETED,
  GET_FORM_VALUES_FAILED,
  SET_FORM_VALUES,
  RESET_INFO,
  GET_SUGGESTED_DATA,
  GET_SUGGESTED_DATA_COMPLETED,
  GET_SUGGESTED_DATA_FAILED,
  RESET_SUGGESTED_DATA
};
